import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { engineerAuthApi, getEngineerToken } from '../../services/engineerService';

const EngineerLogin: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [pin, setPin] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (getEngineerToken()) navigate('/engineer/today', { replace: true });
  }, [navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (!/^\d{6}$/.test(pin)) {
      setError('PIN must be 6 digits');
      return;
    }
    setLoading(true);
    try {
      await engineerAuthApi.loginWithPin(email.trim(), pin);
      navigate('/engineer/today', { replace: true });
    } catch (err: any) {
      setError(err?.response?.data?.message || 'Invalid email or PIN');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8F8F7] flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="flex items-center justify-center mb-5">
          <div className="h-11 w-11 rounded-xl bg-orange-500 text-white flex items-center justify-center font-bold text-lg shadow-sm">
            C
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-[#E6E6E4] p-6">
          <h1 className="text-xl font-semibold text-[#181818]">Engineer sign in</h1>
          <p className="text-sm text-[#686E6C] mt-1">
            Enter your email and 6-digit PIN to start your day.
          </p>

          <form onSubmit={handleSubmit} className="mt-6 space-y-4">
            <div>
              <label className="block text-xs font-semibold text-[#181818] mb-1.5">Email</label>
              <input
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-lg border border-[#E6E6E4] px-3 py-2 text-sm text-[#181818] focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
              />
            </div>

            <div>
              <label className="block text-xs font-semibold text-[#181818] mb-1.5">PIN</label>
              <input
                type="password"
                inputMode="numeric"
                pattern="\d{6}"
                maxLength={6}
                required
                value={pin}
                onChange={(e) => setPin(e.target.value.replace(/\D/g, '').slice(0, 6))}
                className="w-full rounded-lg border border-[#E6E6E4] px-3 py-3 text-2xl tracking-[0.5em] text-center font-mono text-[#181818] focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                placeholder="••••••"
              />
            </div>

            {error && (
              <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-md px-3 py-2">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-orange-500 hover:bg-orange-600 disabled:opacity-60 text-white font-semibold py-3 rounded-lg shadow-sm"
            >
              {loading ? 'Signing in…' : 'Sign in'}
            </button>
          </form>

          <p className="text-xs text-[#9CA3AF] mt-6 text-center">
            First time here? Use the link in your invite email.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EngineerLogin;
